export default function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_includesWith.js
// module id = 227
// module chunks = 1